import restApi from "../../http.js";
import env from "../../env.js";

export default class CareersApi {
  getJobs() {
    return restApi({
      method: "get",
      url: "https://api.airtable.com/v0/appnhQAAp5rKtJc4i/Careers?api_key=" + env.airTableToken(),
    });
  }

  applyForJob(model) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/appq7jrcI8DI0yCZE/Applicants",
      data: {
        fields: {
          "First Name": model.firstName,
          "Last Name": model.lastName,
          "Email Address": model.emailAddress,
          "Phone number": model.phoneNumber,
          "referred by": model.referredBy,
          "Job position": model.jobPosition,
          "client facing experience": model.customerServiceExperience,
          "Experience in visual or merchandising": model.displayOrMerchandisng,
          "working hours": model.workingHours,
          "linkedIn profile link": model.linkedInUrl,
          "anything else you want us to know": model.anythingElse,
          "Hear about bulletin": model.hearAboutBulletin,
          "Link to CV": model.url,
        },
      },

      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }
}
